<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;margin-bottom: 150px;">
    <div class="admin-main-container-content">
      <div class="header-title-admin">{{'' | i18n: 'calc-log'}}</div>

      <div class="blacklist-container2">
        <div class="filter-item-btn">
          {{'' | i18n: 'vin'}}:
          <input type="text" name="dealerName" [(ngModel)]="vin" id="dealerName"
            placeholder="{{'' | i18n: 'vehicle-identification-number'}}" style="width: 200px;">
            <button (click)="searchVin()" [disabled]="!vin || vin.length !== 17" class="button button-create"
              style="width: 200px;">{{'' | i18n: 'search-vin'}}
            </button>
          </div>
        </div>

        <div class="form-row-container-blacklist mt-3">
          <div class="table-header">
            <div class="table-header-item-md">{{'' | i18n: 'date-created'}}</div>
            <div class="table-header-item-md">{{'' | i18n: 'warranty-number'}}</div>
            <div class="table-header-item-lg">{{'' | i18n: 'log'}}</div>
          </div>
          @for (d of logList; track d) {
            <div class="table-list">
              <div class="table-list-item-md">{{ d.dateCreated }}</div>
              <div class="table-list-item-md">{{ d.warrantyNumber }}</div>
              <div class="table-list-item-lg">{{ d.log }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
